import {
  SET_PREVIEW_QUIZ,
  SET_PREVIEW_QUIZ_SUCCESS,
  SET_PREVIEW_QUESTIONLIST,
  SET_PREVIEW_QUESTIONLIST_SUCCESS,
  SET_PREVIEW_DISPLAY,
  SET_PREVIEW_DISPLAY_SUCCESS,
  SET_PREVIEW_QUIZ_SETTINGS,
  SET_PREVIEW_QUIZ_SETTINGS_SUCCESS
} from './constants';
//--------------------------------------------------------------------------------------------------------------------
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setPrewievQuiz = val => ({ type:  SET_PREVIEW_QUIZ, val });
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setPrewievQuizSuccess = val => ({ type: SET_PREVIEW_QUIZ_SUCCESS, val });
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setPrewievQuestionList = val => ({ type: SET_PREVIEW_QUESTIONLIST, val });
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setPrewievQuestionListSuccess  = val => ({ type:  SET_PREVIEW_QUESTIONLIST_SUCCESS, val });
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setDisplayView = val => ({ type: SET_PREVIEW_DISPLAY, val });
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setDisplayViewSuccess  = val => ({ type:  SET_PREVIEW_DISPLAY_SUCCESS, val });
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setQuizSettings = val => ({ type: SET_PREVIEW_QUIZ_SETTINGS, val });
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setQuizSettingsSuccess  = val => ({ type: SET_PREVIEW_QUIZ_SETTINGS_SUCCESS, val });

export {
  setPrewievQuiz,
  setPrewievQuizSuccess,
  setPrewievQuestionList,
  setPrewievQuestionListSuccess,
  setDisplayView,
  setDisplayViewSuccess,
  setQuizSettings,
  setQuizSettingsSuccess
};
